import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';
import AveragePrice from './AveragePrice';
import AveragePriceByChildAge from './AveragePriceByChildAge';
import AveragePriceByNativityOfParents from './AveragePriceByNativityOfParents';
import AveragePriceByRace from './AveragePriceByRace';
import AveragePriceBySettingType from './AveragePriceBySettingType';
import PriceOfChildcareVsPriceOfHousing from './PriceOfChildcareVsPriceOfHousing';
import ErrorBoundary from '../ErrorBoundary';

function Q1Row2() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
      >
        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            Affordability of care by family type
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={10} sm={6}>
              <MessageBox>
                <ErrorBoundary>
                  <AveragePrice />
                </ErrorBoundary>
              </MessageBox>
            </Grid>
          </Grid>

        </Grid>
        <Grid item xs={12} sm={6}>
          <ErrorBoundary>
            <AveragePriceBySettingType height={310} />
          </ErrorBoundary>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ErrorBoundary>
            <AveragePriceByChildAge height={310} />
          </ErrorBoundary>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ErrorBoundary>
            <AveragePriceByNativityOfParents height={310} />
          </ErrorBoundary>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ErrorBoundary>
            <PriceOfChildcareVsPriceOfHousing height={310} />
          </ErrorBoundary>
        </Grid>
        <Grid item xs={12}>
          <ErrorBoundary>
            <AveragePriceByRace height={310} />
          </ErrorBoundary>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default Q1Row2;
